const slider = [
  {
    id:1,
    image:
      "https://dkstatics-public.digikala.com/digikala-adservice-banners/3335bfd1cf002ab42a05b0271c3d04e65e145705_1729599699.jpg?x-oss-process=image/quality,q_95",
  },
  {
    id: 2,
    image:
      "https://dkstatics-public.digikala.com/digikala-adservice-banners/ee8605630e7dd432578694f0ea0ed27325cbeb20_1729415712.gif?x-oss-process=image",
  },
  {
    id:3 ,
    image:'https://dkstatics-public.digikala.com/digikala-adservice-banners/0264b76665bbc39287eef2d30473b63c8691fca2_1729415456.jpg?x-oss-process=image/quality,q_95'
  },
  {
    id: 4,
    image:'https://dkstatics-public.digikala.com/digikala-adservice-banners/e3611e4f0d72c272950475d3d7a145ebfe606c5b_1729414856.jpg?x-oss-process=image/quality,q_95'
  },
  {
    id: 5,
    image:'https://dkstatics-public.digikala.com/digikala-adservice-banners/3f928d8ef8bc7cce4c9f2dda1e2808b762a9e596_1729415191.jpg?x-oss-process=image/quality,q_95'
  },
  {
    id:6,
    image:'https://dkstatics-public.digikala.com/digikala-adservice-banners/eeaa423bfbc38ed4263552e142493c50b075a3cd_1729415628.jpg?x-oss-process=image/quality,q_95'
  },

];

const dbString = JSON.stringify(slider)
localStorage.setItem('db',dbString)



